var map = {
	"./de/nationalities": [
		"lNev",
		54
	],
	"./en/nationalities": [
		"+wr7",
		38
	],
	"./fr/nationalities": [
		"9v5R",
		22
	],
	"./nl/nationalities": [
		"g6b7",
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "AuZr";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/nationalities$
// module id = AuZr
// module chunks = 97